import React from "react";
import styles from "../TemporaryPinModal.module.scss";

interface SendTemporaryPinProps {
  customerEmail: string;
  sendEmail: boolean;
  onSendEmailChange: (value: boolean) => void;
  onSendPin: () => void;
  onCancel: () => void;
  onBack: () => void;
}

const SendTemporaryPin: React.FC<SendTemporaryPinProps> = ({
  customerEmail,
  sendEmail,
  onSendEmailChange,
  onSendPin,
  onCancel,
  onBack,
}) => {
  return (
    <div>
      <div className={styles.header}>
        <button className={styles.backButton} onClick={onBack}>
          <i className="fas fa-arrow-left" style={{ fontSize: 18 }} />
        </button>
      </div>

      <div className={styles.titleSection}>
        <h2 className={styles.title}>Send a Temporary PIN</h2>
        <p className={styles.subtitle}>
          Choose how to deliver the temporary PIN to this user.
        </p>
      </div>

      <div className={styles.deliverySection}>
        <p className={styles.deliverySectionLabel}>Delivery Method</p>

        <div
          className={`${styles.deliveryCard} ${styles.deliveryCardSelected} ${styles.deliveryCardLocked}`}
        >
          <i className={`fas fa-comment-alt ${styles.deliveryIcon}`} />
          <div className={styles.deliveryTextContent}>
            <p className={styles.deliveryCardTitle}>Send via SMS</p>
            <p className={styles.deliveryCardDescription}>
              Always sent to registered number.
            </p>
          </div>
          <span
            className={`${styles.radioIndicator} ${styles.radioIndicatorChecked}`}
          />
        </div>

        <div
          className={`${styles.deliveryCard} ${sendEmail ? styles.deliveryCardSelected : ""}`}
          onClick={() => onSendEmailChange(!sendEmail)}
        >
          <i className={`fas fa-envelope ${styles.deliveryIcon}`} />
          <div className={styles.deliveryTextContent}>
            <p className={styles.deliveryCardTitle}>Also send via email</p>
            <p className={styles.deliveryCardDescription}>{customerEmail}</p>
          </div>
          <span
            className={`${styles.radioIndicator} ${sendEmail ? styles.radioIndicatorChecked : ""}`}
          />
        </div>
      </div>

      <div className={styles.actionButtons}>
        <button className={styles.primaryButton} onClick={onSendPin}>
          Send PIN
        </button>
        <button className={styles.secondaryButton} onClick={onCancel}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default SendTemporaryPin;
